import { environment } from '@environment';
import {
  createBingPixelConfig,
  createDelightedConfig,
  createFacebookPixelConfig,
  createGoogleAnalyticsConfig,
  createGoogleRetargetingConfig,
  createHotjarConfig,
  createSnapchatPixelConfig,
  createTiktokPixelConfig,
  createWizbiiAnalyticsConfig,
  TrackingConfig,
} from '@wizbii/tracking';

export const trackingConfig: TrackingConfig = {
  uuidSetterDomain: `https://a.${environment.domain.wizbii}`,

  consentWidget: {
    version: environment.platform !== 'prod' ? 'staging' : '',
    apiDomain: environment.api.domain,
    locale: 'fr',
    productId: environment.applicationId,
    productLabel: 'Wizbii Money',
    labels: {},
  },

  trackers: {
    analytics_wizbii: createWizbiiAnalyticsConfig(
      environment.trackers.analyticsId,
      `https://a.${environment.domain.wizbii}`
    ),
    analytics_google: createGoogleAnalyticsConfig(environment.trackers.analyticsId),
    marketing_google: createGoogleRetargetingConfig(environment.trackers.gaConversionId),
    analytics_hotjar: createHotjarConfig(environment.trackers.hotjar),
    analytics_delighted: createDelightedConfig(environment.trackers.delighted),
    analytics_facebook_pixel: createFacebookPixelConfig(environment.trackers.facebook),
    analytics_snapchat_pixel: createSnapchatPixelConfig(environment.trackers.snapchat),
    analytics_tiktok_pixel: createTiktokPixelConfig(environment.trackers.tiktokId),
    analytics_bing: createBingPixelConfig(environment.trackers.bingId),
  },
  informationGroupKeys: ['technical'],
};
